var bcrypt = require('bcryptjs');

const SALT = "$2a$10$cIOsAd/R7KEGKdVm3MGZou"

const hash_password = (password) => {
    return bcrypt.hash(password, SALT)
}

const check_hashed_password = (hashed_password) => {
    bcrypt.compare(hashed_password, hash)
}

const password_hash_manager = {
    hash_password,
    check_hashed_password,
}

const Bcrypt = {
    password_hash_manager: password_hash_manager,
}

export default Bcrypt
